import { useMutation } from "@tanstack/react-query";
import mediaGenerationApiClient, {
  GeneratePreviewVideoRequest,
} from "../mediaGeneration";

const useGeneratePreviewVideoMutation = () => {
  return useMutation({
    mutationKey: ["generate-preview-video"],
    mutationFn: async (request: GeneratePreviewVideoRequest) => {
      const response =
        await mediaGenerationApiClient.generatePreviewVideo(request);
      return response;
    },
  });
};

export default useGeneratePreviewVideoMutation;
